// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box,  Typography, Grid } from '@mui/material';

// TODO: Import MUI icon
import { AccountCircle } from '@mui/icons-material';

// TODO: Import context
//import { Context } from '../Common/Context';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';
import { BoxGridColumnsContainer } from '../Common/BoxGridColumns';
import BoxImage from '../Common/BoxImage';
import DialogImage from '../Common/DialogImage';

const P202502111110 = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component P202502111110 Rendered');

    // TODO: Define useContext
    //const context = React.useContext(Context);

    // TODO: Define reference

    // TODO: Define variable
    const names = [
        'Au-Yeung Chi Hang',
        'Chan Wai Hin',
        'Chau Shun Yin',
        'Cheng Ying Ella',
        'Cheung Cheuk Lam',
        'Chong Wing Shan',
        'Gao Mingrui',
        'Ku Fung Yuen',
        'Lam Hei Ching',
        'Lam Kai Yee',
        'Lam Oi Chin',
        'Lau Chak Yin',
        'Lau Chun Hei',
        'Lau Hoi Lam',
        'Lau Sze Wing',
        'Lau Tsz Kiu',
        'Law Man Yee',
        'Leung Chun Hong',
        'Li Hui Lok',
        'Shih Hoi Lam',
        'So Hei Man',
        'Suen Sung Ming',
        'Sze Wan Yan',
        'Tai Pik Tung',
        'Tam Yat Sing',
        'Tang Mei Lin',
        'Tsoi Wai Wong',
        'Wu Lok Yan',
        'Wu Luolin',
        'Wu Pak Hei',
        'Xie Lam Fung',
        'Ye Jiajun',
        'Yeung Ching Shun',
        'Yeung Ming Yuet',
        'Yip Tsz Lok',
        'Yuen Ho Hin',
        'Zhang Hao Yu',
    ];

    const [src, setSrc] = React.useState(null);

    // TODO: Define event
    const handleDialogClosed = () => { setSrc(null) };

    // TODO: Return component

    return (
        <BoxSubPage
            disableMenu={true}
            disableSubtitle={true}
            id="P202502111110"
            title="Choral Speaking Champions: 76th Hong Kong Schools Speech Festival"
        >
            <Box component="img" src="https://www.pohtyh.edu.hk/Files/Pages/P202502111110/A.jpg" sx={{ width: { xs: 1, sm: 0.8, md: 0.5 } }} />
            <Typography variant="body1">Congratulations to the Form 3 Choral Speaking team who won the championship of the 76th Hong Kong Schools Speech Festival for Tang Ying Hei College! The team was recommended by the adjudicator to perform again at the 76th Prize-Winners’ Recital on 18 January 2025. This was a remarkable achievement, as only 3 winning teams were chosen to perform Choral Speaking in English at the recital – across all ages, all gender categories and all of Hong Kong! In additional exciting news, the group continued to achieve, winning 1st place at the Greater Bay Speech Festival.</Typography>
            <Box sx={{ mb: 2, width: { xs: 1, sm: 0.8, md: 0.5 } }}>
                <video autoPlay controls width="100%" height="100%">
                    <source src="https://www.pohtyh.edu.hk/Files/Pages/P202502111110/V1.mp4" type="video/mp4" />
                </video>
            </Box>
            <Typography variant="body1">Well done to the following students from Class 3A and Class 3B:</Typography>
            <Grid container spacing={2} sx={{ maxWidth: '800px', my: 2 }}>
                {names.map((name) => (
                    <Grid size={{ xs: 6, sm: 4, md: 3 }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <AccountCircle color="primary" />
                            <Typography variant="body1">{name}</Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <BoxGridColumnsContainer>
                <Box onClick={() => { setSrc(`https://www.pohtyh.edu.hk/Files/Pages/P202502111110/B.jpg`) }}>
                    <BoxImage hover={true} src={`https://www.pohtyh.edu.hk/Files/Pages/P202502111110/B.jpg`} />
                </Box>
                <Box onClick={() => { setSrc(`https://www.pohtyh.edu.hk/Files/Pages/P202502111110/C.jpg`) }}>
                    <BoxImage hover={true} src={`https://www.pohtyh.edu.hk/Files/Pages/P202502111110/C.jpg`} />
                </Box>
                {Array.from({ length: 12 }, (_, index) => `${index + 1}.jpg`).map(image => (
                    <Box onClick={() => { setSrc(`https://www.pohtyh.edu.hk/Files/Pages/P202502111110/${image}`) }}>
                        <BoxImage key={image} hover={true} src={`https://www.pohtyh.edu.hk/Files/Pages/P202502111110/${image}`} />
                    </Box>))}
            </BoxGridColumnsContainer>
            {src && <DialogImage src={src} onClose={handleDialogClosed} />}
            <Typography variant="body1">The team shared that it was a great honour to represent the school. From this whole experience, the students discovered a love for performing on-stage in front of an audience. They learned the power of teamwork, alongside the significance of building synergy and harmony within a group. Many thanks to everyone who supported the team throughout their journey!</Typography>
        </BoxSubPage>
    );
}

export default P202502111110;